import { jsxs as h, jsx as t } from "react/jsx-runtime";
const l = ({ size: c = 52, color: r = "currentColor", ...o }) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: c,
    height: c,
    viewBox: `0 0 ${c} ${c}`,
    fill: "none",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "m30.1109 25.3104c4.5602 1.6552 7.7384 6 7.8766 10.8965 0.1382 0.8964-0.8981 1.7931-1.7964 1.7931h-20.3822c-0.8981 0-1.9346-0.8965-1.7964-1.7931 0.1382-4.8965 3.3164-9.2413 7.8766-10.8965-1.3819-1.1723-2.28-2.9655-2.28-4.8964 0-3.5173 2.8328-6.414 6.3567-6.414 3.5929 0 6.4258 2.8965 6.4258 6.414 0 1.9311-0.8982 3.7242-2.28 4.8964zm-4.1455-8.9657c-2.211 0-4.0073 1.7932-4.0073 4.0689 0 2.207 1.7964 4 4.0073 4 2.28 0 4.0764-1.7932 4.0764-4 0-2.2758-1.7965-4.0689-4.0764-4.0689zm0 10.5519c-4.9746 0-9.12 3.793-9.6039 8.7587h19.2078c-0.4146-4.9654-4.6293-8.7587-9.6039-8.7587z",
          fill: r
        }
      ),
      /* @__PURE__ */ t("circle", { cx: "26", cy: "26", r: "25", stroke: r, strokeWidth: "2" })
    ]
  }
);
export {
  l as UserCircleIcon
};
